export default __webpack_public_path__ + "static/media/img (1).ee6d74a2.jpg";